import Conclave from '../components/conclave';

export default function Productivityconclave() {
  return (
    <Conclave
      geturl="https://cpccbe.org/api/productivityconclave/allmodals"
      createmodel1url="https://cpccbe.org/api/productivityconclave/modal/modal1"
      createmodel2url="https://cpccbe.org/api/productivityconclave/modal/modal2"
      updateurl="https://cpccbe.org/api/productivityconclave/modal"
      deleteurl="https://cpccbe.org/api/productivityconclave/modal"
      head="Productivity Conclave"
    />
  );
}
